import React from 'react'
import { Link } from 'react-router-dom'
import GreenButton from './greenButton'

const New = ({to}) => {
  return (
    <div className='forms_new_container'>
      <Link to={to}>
        <GreenButton Value='Add'/>
      </Link>
    </div>
  )
}

export default New
